import React, { useCallback } from 'react';
import { Dropdown, Text, notify } from '@shootsta/common-react';
import type { VideoShareSettings, UpdateInput } from '../hooks/useVideoShareSettings';

const ACCESS_LEVEL_OPTIONS = [
  { label: 'View only', value: 'GUEST' },
  { label: 'View & Comment', value: 'GUEST_COMMENTER' }
];

type AccessLevelSelectorProps = {
  settings: VideoShareSettings | null;
  updateSettings: (input: UpdateInput) => Promise<any>;
  disabled?: boolean;
};

function AccessLevelSelector({
  settings,
  updateSettings,
  disabled = false
}: AccessLevelSelectorProps) {
  const currentAccessLevel = settings?.accessLevel || 'GUEST';

  const selectedOption = ACCESS_LEVEL_OPTIONS.find(
    (opt) => opt.value === currentAccessLevel
  );

  const handleChange = useCallback(
    async (selected: { label: string; value: string }) => {
      try {
        const accessLevel = selected.value as 'GUEST' | 'GUEST_COMMENTER';
        await updateSettings({ shareStatus: 'PUBLIC', accessLevel });
        notify({ content: 'Access level updated', type: 'success' });
      } catch {
        notify({ content: 'Failed to update access level', type: 'error' });
      }
    },
    [updateSettings]
  );

  if (settings?.shareStatus !== 'PUBLIC') {
    return null;
  }

  return (
    <div className="video-share-modal__access-level">
      <Text noMargin highlighted>
        Anyone with the link can
      </Text>
      <Dropdown
        className="video-share-modal__access-level__dropdown"
        type="BASIC"
        onChange={handleChange}
        defaultValue={selectedOption}
        options={ACCESS_LEVEL_OPTIONS}
        disabled={disabled}
      />
    </div>
  );
}

export default AccessLevelSelector;
